import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { NavLink, withRouter } from "react-router-dom";

import { Navigation } from "./navigation";
import Player from "../../components/shared/Player";
import { VideoListingComponent } from "./videosListing";
import { LoaderComponent } from "../../components/loader";
import cosmeticConfig from '../../../config/cosmeticConfig';
import { getEnv } from "../../../helpers/env";

// actions
import {
  getCompanySubMenuAction,
  getCompanySubMenuDataAction,
  resetCompanyResults,
  setSignupModalStatus,
  getPromotedCompaniesIdList
} from "../../actions";

import { 
  IsEmpty, 
  returnDate, 
  secondToTime, 
  convertToSlug, 
  redirectionWrapper, 
  getParameterByName, 
  getLastInputFromUrl, 
  followButtonClicked, 
  unFollowButtonClicked, 
  getAssociationUrlPrefix, 
  sanitizeAndProcessHtml
} from "../../util/commonFunctions";

import "../../company.css"

class CompanyPage extends PureComponent {
  state = {
    activeTier: null,
    offset: cosmeticConfig.company.OFFSET,
    max: cosmeticConfig.company.MAX,
    isFollowing: false,
    lastScrollTop: 0,
    companyID: null,
  };

  componentDidMount() {
    // get sub Menu List
    const { match: { url } = {}, location: { search } = {} } = this.props;
    let companyID = this.getCompanyID();
    this.state.companyID =  this.getCompanyID();
    const isLoggedin = !IsEmpty(localStorage.getItem("token"))
    if(isLoggedin) {
      if (!IsEmpty(localStorage.getItem("userLastKnownLocation")) && decodeURIComponent(localStorage.getItem("userLastKnownLocation")) == getEnv("BASE_URL") + this.props.match.url + search && !IsEmpty(localStorage.getItem("isFollowClicked")) ){
        localStorage.setItem("userLastKnownLocation", '');
        this.followCompanyClicked()
      }
    }else {
      this.setState({isFollowing: false})
    }
    localStorage.setItem("isFollowClicked", '');
    this.getSubMenusList(companyID);
    this.getSubMenuListData(companyID);
    this.lazyLoadContainer = React.createRef();
    window.addEventListener("scroll", this.onScroll, false); // bind scroll event
  }

  openSigninModalPopup = (formName = "signin") => {
    this.props.setSignupModalStatus(true, formName);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  componentDidUpdate(prevProps) {
    const {
      match: { url: newUrl },
      location: { search } = {}
    } = this.props;
    const {
      match: { url: oldUrl }
    } = prevProps;
    let companyID = this.getCompanyID()
    if (oldUrl !== newUrl) {
      this.setState(
        {
          offset: 0,
          isFollowing: false
        },
        () => {
          this.props.resetCompanyResults();
          this.getSubMenusList(companyID);
          this.getSubMenuListData(companyID);
        }
      );
    }
  }

  getCompanyID = () => {
    const {
      location: { search } = {}
    } = this.props;
    let companyID = getParameterByName("companyID", search );
    if(!companyID || companyID == null){
      companyID = getLastInputFromUrl( search );
    }
    return companyID
  }


  followCompanyClicked = () => {
    const isLoggedin = !IsEmpty(localStorage.getItem("token"))
    let companyID = this.getCompanyID()
    if(isLoggedin){
        followButtonClicked(this.followButtonApiHandler, localStorage.getItem("token") , companyID)
    }else {
      localStorage.setItem("isFollowClicked", true);
      this.openSigninModalPopup("signin")
    }
  }

  followButtonApiHandler = (response,error) => {
    if(response){
      this.setState({
        isFollowing: true
      })
    }
  }

  unFollowCompanyClicked = () => {
    let companyID = this.getCompanyID()
    unFollowButtonClicked(this.unFollowButtonApiHandler, this.props.token, companyID)
  }

  unFollowButtonApiHandler = (response, error) => {
    if (response) {
      this.setState({
        isFollowing: false
      })
    }
  }

  getSubMenusList = async id => {
    const { getCompanySubMenuAction, getPromotedCompaniesIdList, currentLanguage } = this.props;
    let token = localStorage.getItem("token")
    await getCompanySubMenuAction({ id, token, language: currentLanguage });
    await getPromotedCompaniesIdList({id, language: currentLanguage});
    this.setState({
      isFollowing: this.props.tierReducer?.subMenu?.isFollowing
    })
  };

  getSubMenuListData = async id => {
    const { max, offset } = this.state;
    const { getCompanySubMenuDataAction, currentLanguage } = this.props;
    let token = localStorage.getItem("token")
    await getCompanySubMenuDataAction({ id, offset, max, token, language: currentLanguage});
  };

  

  ///  lazy load on scroll
  onScroll = () => {
    const {
      match: { url } = {},
      location: { search } = {},
      tierReducer: { isSubMenuDataLoading, subMenuData, prmCompany }
    } = this.props;
    const {
      lastScrollTop
    } =  this.state
    let companyID = this.getCompanyID()
    const {
      top: containerTop
    } = !prmCompany.is_new_ui && this.lazyLoadContainer.current.getBoundingClientRect();
    var st = window.pageYOffset || document.documentElement.scrollTop; 
    if (st > lastScrollTop) {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st 
      })
      // downscroll code
    } else {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      return;
      // upscroll code
    }
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
      const listing =
        subMenuData &&
        Object.values(subMenuData).map(values => values.contentResults);
      const lastList =
        Array.isArray(listing) && listing.length && listing[listing.length - 1];
        const totalCount =
        subMenuData &&
        Object.values(subMenuData).map(values => values.totalCount);
      if (!isSubMenuDataLoading && containerTop < 100 && lastList.length && this.state.offset <= totalCount) {
        this.setState(
          prevState => ({
            offset: prevState.offset + prevState.max
          }),
          () => {
            this.getSubMenuListData(companyID);
          }
        );
      }
    }
  };

  // on click on navigation tier
  onTierClicked = async({ id }) => {
  };

  render() {
    const { onTierClicked, followCompanyClicked, unFollowCompanyClicked } = this;
    const { tierReducer, location } = this.props;
    const {
      subMenu = {},
      subMenuData = {},
      prmCompany,
      isSubMenuDataLoading,
      isPromotedIdListLoading,
    } = tierReducer;
    //Total items count and items from list
    let totalResults = 0;
    const listing =
      subMenuData &&
      Object.values(subMenuData).map(values => {
        totalResults += values.contentResults
          ? values.contentResults.length
          : 0;
        return values.contentResults;
      });
    const hasRelatedVods = prmCompany && prmCompany.related_vods && prmCompany.related_vods.length > 0;
    const relatedVods = hasRelatedVods && prmCompany.related_vods;
    const showPresentations = hasRelatedVods && prmCompany.related_vods.length > 1;
    return (
      <React.Fragment>
        <div className="contentWhite">
          <section className="tier-container">
            <LoaderComponent isLoading={isSubMenuDataLoading || isPromotedIdListLoading} />
            <section className="tier-navigation">
              <Navigation
                title={subMenu}
                pathName={location && location.pathname}
                followCompanyClicked={followCompanyClicked}
                isFollowing={this.state.isFollowing}
                onTierClicked={onTierClicked}
                unFollowCompanyClicked={unFollowCompanyClicked}
                listing={subMenu?.relatedTopics}
                companyID={this.state.companyID}
                contentArr={listing?.length > 0 ? listing[0] : []}
              />
            </section>
            {prmCompany && prmCompany.is_new_ui === true && !isSubMenuDataLoading ? 
              <>
                <section className="container company-prm">
                  <div className="row"> 
                    {hasRelatedVods &&
                      <div className="col-md-7 bordered">
                        <>
                          <NavLink
                            to={{
                              pathname:
                                "/company-media/" +
                                convertToSlug(relatedVods[0].title) +
                                "?videoId=" +
                                relatedVods[0].id + "&companyId=" + this.state.companyID
                            }}
                          >
                            <h1>
                              {relatedVods[0].title}
                            </h1>
                          </NavLink>
                          <Player 
                            videoUrl={
                              {
                                dash: null,
                                hls: null,
                                progressive: relatedVods[0].videoUrl
                              }
                            }
                            playerTimeout={
                              15
                            }
                            playVideo={true}
                            startPosition={0}
                            playlist={relatedVods}
                            enableOverlayFun={() => {}}
                          />
                        </>                      
                      </div>
                    }
                    {prmCompany.description && typeof(prmCompany.description) === "string" && 
                      <div className={`${hasRelatedVods ? 'col-md-5' : 'col-md-12'}`}>
                        <h1>About {subMenu?.shortName}</h1>
                        <p dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(prmCompany.description)}}></p>
                      </div>
                    }
                  </div>
                </section>
                <section className="container company-prm">
                    <div className="row interviews-container">
                      {showPresentations && 
                        <div className="col-md-7 bordered interviews-and-presentation">
                          <h1>Company Interviews and presentations</h1>   

                          <div className="interview-list">
                            {relatedVods.slice(1, 5).map((item, i) => {
                                let redirectUrl = getAssociationUrlPrefix(item.associationType);
                                let associationId = item.associationId == null ? item.topic?.id : item.associationId;
                                let associationName = item.associationName == null ? item.topic?.name : item.associationName;
                                return (                      
                                  <div key={i} className={`${i % 2 ? "left" : "right"}`}>
                                    <figure className="figure">
                                      <NavLink
                                        to={{
                                          pathname:
                                            "/company-media/" +
                                            convertToSlug(item.title) +
                                            "?videoId=" +
                                            item.id + "&companyId=" + this.state.companyID
                                        }}
                                      >                                    
                                        <img
                                          src={item.path}
                                          className="figure-img img-fluid"
                                          alt={item.title}
                                          width="1024px"
                                          height="576px"
                                        />
                                        <div className="duration">
                                          <span></span>
                                          {secondToTime(item.duration)}
                                        </div>
                                      </NavLink>
                                      <div className="vodInfo text-left">
                                        <NavLink
                                          to={{
                                            pathname:
                                              "/company-media/" +
                                              convertToSlug(item.title) +
                                              "?videoId=" +
                                              item.id + "&companyId=" + this.state.companyID
                                          }}
                                          style={{ color: "#333" }}
                                        >
                                          <h4>{item.title}</h4>
                                        </NavLink>
                                        <ul className="d-flex flex-row justify-content-between vod_com_time">
                                          <li className={item.following ? "video-verified" : null}>
                                            <a
                                              href={`/${redirectUrl}/${associationName}/${associationId}`}
                                              onClick={event => {
                                                redirectionWrapper(
                                                  redirectUrl,
                                                  event,
                                                  associationId,
                                                  associationName,
                                                  props,
                                                  props.showLoader,
                                                  props.hideLoader,
                                                  props.currentLanguage
                                                )
                                              }
                                              }
                                            >
                                              {!IsEmpty(associationName) ? associationName : ""}
                                            </a>
                                          </li>
                                          <li>{returnDate(item.publish_date)}</li>
                                        </ul>
                                      </div>
                                    </figure>
                                  </div>
                                )
                              })
                            }                      
                          </div>             
                        </div>
                      }
                      {listing && listing.length > 0 && listing[0] && listing[0].length > 0 &&
                        <div className={`${showPresentations ? 'col-md-5' : 'col-md-12'} other-related-news`}>
                          <h1>Other news relating to {subMenu?.shortName}</h1> 
                          <div>
                            {listing[0].map((item, index) => {
                              return (
                                <NavLink
                                  key={index}
                                  to={{
                                    pathname:
                                      "/company-media/" +
                                      convertToSlug(item.title) +
                                      "?videoId=" +
                                      item.id + "&companyId=" + this.state.companyID
                                  }}
                                >
                                  <div className="related-news" key={index}>
                                    <div className="col-md-4 related-news-image-container">
                                      <img className="related-news-image" src={item.imageUrl} />
                                    </div>
                                    <div className="col-md-8 news-text">
                                      <p className="news-description">Company News /{item.experts[0] ?  `by ${item.experts[0].name}` : ""} - {returnDate(item.upload_time)}</p>
                                      <p className="news-title">
                                        {item.title}
                                      </p>
                                      <p dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(item.desc)}} className="news-description">
                                      </p>
                                    </div>
                                  </div>
                                </NavLink>
                              )
                            })}
                          </div>
                        </div>
                      }
                    </div>
                </section>
                {prmCompany.disclosure && typeof(prmCompany.disclosure) === "string" && 
                  <section className="container company-prm">
                    <h1>Disclosure</h1>
                    <p dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(prmCompany.disclosure)}}></p>
                  </section>
                }
              </>
              :
              <section
                className="container tier-listing"
                ref={this.lazyLoadContainer}
              >
                <div className="row">
                  <VideoListingComponent
                    listing={listing}
                    totalResults={totalResults}
                    isLoading={!isSubMenuDataLoading && !isPromotedIdListLoading}
                  />
                </div>
              </section>
            } 
          </section>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    tierReducer: state.companyPage,
    token: state.auth.token,
    currentLanguage: state.language.currentLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCompanySubMenuAction,
      getPromotedCompaniesIdList,
      getCompanySubMenuDataAction,
      resetCompanyResults,
      setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
    },
    dispatch
  );
}

function loadData(store) {
  return store.dispatch(getCompanySubMenuDataAction());
}

export default {
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(CompanyPage)
};
